'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _bid = require('./remote/bid');

var Bid = {
    postPlaceAbsenteeBid: function postPlaceAbsenteeBid(params) {
        return _bid.BidRemote.postPlaceAbsenteeBid(params);
    },
    postPlaceLiveBid: function postPlaceLiveBid(params) {
        return _bid.BidRemote.postPlaceLiveBid(params);
    },
    postRetractBid: function postRetractBid(params) {
        return _bid.BidRemote.postRetractBid(params);
    }
};

exports.default = Bid;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/bid.js
// module id = c28x
// module chunks = 46